var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5C16.215 5 5 16.215 5 30s11.215 25 25 25c7.258 0 13.8-3.111 18.371-8.067.035-.029.061-.062.092-.095C52.52 42.39 55 36.48 55 30 55 16.215 43.785 5 30 5zm0 48c-6.506 0-12.385-2.72-16.572-7.076 2.615-6.848 9.2-11.42 16.572-11.42 7.38 0 13.958 4.57 16.572 11.42C42.384 50.282 36.506 53 30 53zm18.047-8.766a19.743 19.743 0 0 0-12.912-11.038c3.344-1.825 5.617-5.373 5.617-9.443C40.752 17.824 35.929 13 30 13s-10.752 4.824-10.752 10.753c0 4.07 2.274 7.62 5.619 9.445-5.686 1.533-10.478 5.55-12.914 11.035A22.88 22.88 0 0 1 7 30C7 17.317 17.317 7 30 7s23 10.317 23 23a22.88 22.88 0 0 1-4.953 14.234zM30 32.504c-4.826 0-8.752-3.925-8.752-8.751S25.174 15 30 15s8.752 3.927 8.752 8.753-3.926 8.752-8.752 8.752z",
    fill: "#000000",
    className: "color000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileicon);
export default __webpack_public_path__ + "static/media/profileicon.3686e495bfe3f69e5ecb9a9ff2813b71.svg";
export { ForwardRef as ReactComponent };